'use client'

import { ReactElement, ReactNode } from 'react'

import { useLocale, useTranslations } from 'next-intl'

import Breadcrumbs from '@/components/site/Breadcrumbs'

import styles from './styles.module.scss'

interface Props {
    title: string
    updatedAt: string
    children: ReactNode
}

export default function LegalDocument({
    title,
    updatedAt,
    children,
}: Props): ReactElement {
    const t = useTranslations('common')
    const tLegal = useTranslations('legal')
    const locale = useLocale()

    return (
        <div className={styles.wrapper}>
            <Breadcrumbs
                items={[
                    { title: t('home'), href: '/' },
                    { title: t('documents'), href: '/legal/requisites' },
                    { title },
                ]}
            />
            <article className={styles.article}>
                <header className={styles.header}>
                    <h1 className={styles.title}>{title}</h1>
                    <p className={styles.updated}>
                        {tLegal('lastUpdated')}
                        {updatedAt}
                    </p>
                </header>
                {locale !== 'ru-RU' ? (
                    <p className={styles.translationPending}>
                        {tLegal('translationPending')}
                    </p>
                ) : null}
                <div className={styles.content}>{children}</div>
            </article>
        </div>
    )
}
